module.exports = __webpack_public_path__ + "img/elementlengths_jak.f037419b.png";